<template>
  <footer v-show="!hideFooter" class="footer">
    <div class="common">
      <center>
        <img class="logo" alt="arztpool.de" src="/images/arztpool-solid-white.svg?url" />
      </center>
      <div class="legal">
        <a href="https://arztpool.de/praxen-mvz">{{ $t('FOOTER.LEGAL.PRACTICES') }}</a>
        <a href="https://arztpool.de/vertreter">{{ $t('FOOTER.LEGAL.REPRESENTATIVES') }}</a>
        <a href="https://arztpool.de/ueber-uns">{{ $t('FOOTER.LEGAL.ABOUT_US') }}</a>
        <a href="https://arztpool.de/faq">{{ $t('FOOTER.LEGAL.FAQ') }}</a>
        <a href="https://arztpool.de/impressum">{{ $t('FOOTER.LEGAL.IMPRINT') }}</a>
        <a href="https://arztpool.de/datenschutz">{{ $t('FOOTER.LEGAL.PRIVACY') }}</a>
        <a href="https://arztpool.de/agb">{{ $t('FOOTER.LEGAL.CONDITIONS') }}</a>
        <a>
          <button @click="showConcentModal">{{ $t('FOOTER.LEGAL.CONCENT') }}</button>
        </a>
      </div>
      <p class="copy-right">&copy;{{ year }} {{ $t('FOOTER.COPYRIGHT') }} (v{{ version }})</p>
    </div>
  </footer>
</template>

<script lang="ts">
  import { defineComponent, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useDisplay } from 'vuetify';

  export default defineComponent({
    name: 'PageFooter',
    setup() {
      const route = useRoute();
      const { smAndDown } = useDisplay();

      // register this const as ref to make it changeable in watcher
      const hideFooter = ref(false);

      // watch for route changes to hide footer on specific pages
      watch(
        () => route.path,
        (value) => {
          hideFooter.value = value === '/wizard';
        },
        {
          immediate: true,
        },
      );

      return {
        smAndDown,
        hideFooter,
        version: APP_VERSION,
      };
    },
    computed: {
      /**
       * get current year
       * @return {number}
       */
      year(): number {
        return new Date().getFullYear();
      },
    },
    methods: {
      async showConcentModal() {
        if ('UC_UI' in window) {
          (window.UC_UI as { showSecondLayer: () => void }).showSecondLayer();
        } else {
          console.error('Usercentrics is not attached to window.');
        }
      },
    },
  });
</script>

<style lang="scss" scoped>
  @import '@/scss/configs/colors';
  @import '@/scss/configs/fonts';

  footer {
    padding-top: 3rem;
    padding-bottom: 5rem;
    padding-inline: 1rem;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    background-color: $color-marine;
    color: $color-white;

    @media (min-width: 960px) {
      padding-top: 5rem;
    }

    a {
      color: $color-white;

      &:hover {
        color: $color-sky;
      }
    }

    .footer-links {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      a,
      button {
        font-size: $font-size-large;
        font-family: $font-semi-bold;
        white-space: nowrap;
      }
    }
  }

  .common {
    display: grid;
    gap: 2rem;
    width: 100%;

    .logo {
      translate: 0 1.25rem;
      max-width: 100%;
    }
  }

  .legal {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem 2rem;
    margin-bottom: 24px;
    justify-content: center;
    font-size: 0.875rem;

    a {
      font-weight: bold;
    }
  }

  .copy-right {
    font-size: 1rem;
    text-align: center;
  }

  .footer {
    display: grid;
    gap: 5rem;
  }
</style>
